import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import {
  getFinanceKPIData,
  getFinanceQuarterlyLiquidityRatiosData,
  getFinanceQuarterlyRevenueAndProfitData,
  getFinanceRiskScoreGraphData,
  getSupplierDebtEquity,
  getSupplierKpiCardData,
  getSupplierLiquidityRatiosData,
  getSupplierRevenueAndMarginData,
  getSupplierZscoreRevenue,
} from './finance.async'

const initialState = {
  supplierDebtEquityLoader: false,
  supplierDebtEquityData: [],
  supplierZscoreLoader: false,
  supplierZscoreData: [],
  supplierKpiCardLoader: false,
  supplierKpiCardData: {},
  supplierRevenueAndMarginLoader: false,
  supplierRevenueAndMarginData: [],
  supplierLiquidityRatiosLoader: false,
  supplierLiquidityRatiosData: [],
  supplierFinanceKpiLoader: false,
  supplierFinanceKpiData: [],
  supplierFinanceRiskScoreGraphLoader: false,
  supplierFinanceRiskScoreGraphData: [],
  supplierFinanceQuarterlyRevenueAndProfitLoader: false,
  supplierFinanceQuarterlyRevenueAndProfitData: [],
  supplierFinanceQuarterlyLiquidityRatiosLoader: false,
  supplierFinanceQuarterlyLiquidityRatiosData: [],
}

const FinanceReducer = createSlice({
  name: 'FinanceReducer',
  initialState,
  reducers: {
    emptyFinanceReducer: (state) => {
      state.supplierDebtEquityData = []
      state.supplierZscoreData = []
      state.supplierKpiCardData = {}
      state.supplierRevenueAndMarginData = []
      state.supplierLiquidityRatiosData = []
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getSupplierDebtEquity.pending), (state) => {
      state.supplierDebtEquityLoader = true
    })
    builder.addMatcher(
      isAnyOf(getSupplierDebtEquity.fulfilled),
      (state, action) => {
        state.supplierDebtEquityLoader = false
        state.supplierDebtEquityData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getSupplierDebtEquity.rejected), (state) => {
      state.supplierDebtEquityLoader = false
    })

    builder.addMatcher(isAnyOf(getSupplierZscoreRevenue.pending), (state) => {
      state.supplierZscoreLoader = true
    })
    builder.addMatcher(
      isAnyOf(getSupplierZscoreRevenue.fulfilled),
      (state, action) => {
        state.supplierZscoreLoader = false
        state.supplierZscoreData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getSupplierZscoreRevenue.rejected), (state) => {
      state.supplierZscoreLoader = false
    })
    builder.addMatcher(isAnyOf(getSupplierKpiCardData.pending), (state) => {
      state.supplierKpiCardLoader = true
    })
    builder.addMatcher(
      isAnyOf(getSupplierKpiCardData.fulfilled),
      (state, action) => {
        state.supplierKpiCardLoader = false
        state.supplierKpiCardData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getSupplierKpiCardData.rejected), (state) => {
      state.supplierKpiCardLoader = false
    })
    builder.addMatcher(isAnyOf(getSupplierRevenueAndMarginData.pending), (state) => {
      state.supplierRevenueAndMarginLoader = true
    })
    builder.addMatcher(
      isAnyOf(getSupplierRevenueAndMarginData.fulfilled),
      (state, action) => {
        state.supplierRevenueAndMarginLoader = false
        state.supplierRevenueAndMarginData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getSupplierRevenueAndMarginData.rejected), (state) => {
      state.supplierRevenueAndMarginLoader = false
    })
    builder.addMatcher(isAnyOf(getSupplierLiquidityRatiosData.pending), (state) => {
      state.supplierLiquidityRatiosLoader = true
    })
    builder.addMatcher(
      isAnyOf(getSupplierLiquidityRatiosData.fulfilled),
      (state, action) => {
        state.supplierLiquidityRatiosLoader = false
        state.supplierLiquidityRatiosData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getSupplierLiquidityRatiosData.rejected), (state) => {
      state.supplierLiquidityRatiosLoader = false
    })

    builder.addMatcher(isAnyOf(getFinanceKPIData.pending), (state) => {
      state.supplierFinanceKpiLoader = true
    })
    builder.addMatcher(
      isAnyOf(getFinanceKPIData.fulfilled),
      (state, action) => {
        state.supplierFinanceKpiLoader = false
        state.supplierFinanceKpiData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getFinanceKPIData.rejected), (state) => {
      state.supplierFinanceKpiLoader = false
    })

    builder.addMatcher(isAnyOf(getFinanceRiskScoreGraphData.pending), (state) => {
      state.supplierFinanceRiskScoreGraphLoader = true
    })
    builder.addMatcher(
      isAnyOf(getFinanceRiskScoreGraphData.fulfilled),
      (state, action) => {
        state.supplierFinanceRiskScoreGraphLoader = false
        state.supplierFinanceRiskScoreGraphData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getFinanceRiskScoreGraphData.rejected), (state) => {
      state.supplierFinanceRiskScoreGraphLoader = false
    })

    builder.addMatcher(isAnyOf(getFinanceQuarterlyRevenueAndProfitData.pending), (state) => {
      state.supplierFinanceQuarterlyRevenueAndProfitLoader = true
    })
    builder.addMatcher(
      isAnyOf(getFinanceQuarterlyRevenueAndProfitData.fulfilled),
      (state, action) => {
        state.supplierFinanceQuarterlyRevenueAndProfitLoader = false
        state.supplierFinanceQuarterlyRevenueAndProfitData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getFinanceQuarterlyRevenueAndProfitData.rejected), (state) => {
      state.supplierFinanceQuarterlyRevenueAndProfitLoader = false
    })

    builder.addMatcher(isAnyOf(getFinanceQuarterlyLiquidityRatiosData.pending), (state) => {
      state.supplierFinanceQuarterlyLiquidityRatiosLoader = true
    })
    builder.addMatcher(
      isAnyOf(getFinanceQuarterlyLiquidityRatiosData.fulfilled),
      (state, action) => {
        state.supplierFinanceQuarterlyLiquidityRatiosLoader = false
        state.supplierFinanceQuarterlyLiquidityRatiosData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getFinanceQuarterlyLiquidityRatiosData.rejected), (state) => {
      state.supplierFinanceQuarterlyLiquidityRatiosLoader = false
    })
  },
})

export const { emptyFinanceReducer } = FinanceReducer.actions
export default FinanceReducer.reducer
